import cn from 'classname';
import React, { Component } from 'react';
import './CommentCell.less';
import {Field, reduxForm} from 'redux-form';
import Input from '../../../shared/form-elements/input';

class CommentCell extends Component {
	constructor(props) {
		super(props);
		this.state = { commentsList: [] };
		this.updateCommentsList = this.updateCommentsList.bind(this);
	}
	updateCommentsList() {
		const { affiliate_id, offer_id } = this.props.data;
		if (affiliate_id) {
			this.props.getCommentsList({ affiliate_id, offer_id })
				.then(data => this.setState({ commentsList: data }));
		}
	}

	render() {
		const { row_number, setActiveRow, activeRowNumber, data, dropComment } = this.props;

		const canRenderCommentForm = !!data.affiliate_id;

		return (
			<div
				className={cn({ 'table_cell': true, 'active': row_number === activeRowNumber, 'comment_cell': true })}
				onMouseEnter={() => { setActiveRow(row_number); this.updateCommentsList(); }}
				onMouseLeave={setActiveRow.bind(null, -1)}
			>
				<span></span>
				{
					canRenderCommentForm &&
					<div className="comments_list">
						{
							this.state.commentsList.map((commentItem, index) =>
								<p key={index} className="comment_item">
									<span>{commentItem.admin}: {commentItem.comment}</span>
									<span
										className="action_delete"
										onClick={() => dropComment(commentItem.id).then(this.updateCommentsList)}
									/>
								</p>
							)
						}
						<div className="add_comment_form">
							<CommentForm {...this.props} updateCommentsList={this.updateCommentsList} />
						</div>
					</div>
				}
			</div>
		);
	}
}

const CommentForm = reduxForm({ form: 'adminCommentForm' })(props =>
	<div className="">
		<form
			action="#"
			onSubmit={props.handleSubmit(data =>
				props.submitComment({...data, affiliate_id: props.data.affiliate_id, offer_id: props.data.offer_id })
					.then(props.updateCommentsList)
			)}
			className="add_comment_form-container"
		>
			<Field
				name="comment"
				placeholder="Enter comment here"
				component={Input}
				showLabel={false}
			/>
			<button className="ui-btn ui-btn-primary apply">
				Add
			</button>
		</form>
	</div>
);

export default CommentCell;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/traffic-accounting/components/table-start/CommentCell.js